import React, { FC } from 'react';
import ContentLoader from 'react-content-loader';
import styled, { useTheme } from 'styled-components';

const Container = styled.div`
    padding: 10px 0;
`;

export const CategoriesSkeleton: FC = () => {
    const theme = useTheme();

    return (
        <Container>
            <ContentLoader
                speed={2}
                width='100%'
                height='300px'
                backgroundColor={theme.skeleton.backgroundColor}
                foregroundColor={theme.skeleton.foregroundColor}
            >
                {/* All Assets item */}
                <rect x='20' y='12' rx='4' ry='4' width='100' height='16' />

                {/* Category items */}
                <rect x='20' y='52' rx='4' ry='4' width='150' height='16' />
                <rect x='20' y='92' rx='4' ry='4' width='130' height='16' />
                <rect x='20' y='132' rx='4' ry='4' width='140' height='16' />
                <rect x='20' y='172' rx='4' ry='4' width='120' height='16' />
                <rect x='20' y='212' rx='4' ry='4' width='160' height='16' />
                <rect x='20' y='252' rx='4' ry='4' width='110' height='16' />
            </ContentLoader>
        </Container>
    );
};
